import React from 'react'

const BottomFooter = () => {
    return (
        <div className="bottom-footer bg-main-one-900 py-8">
            <div className="container container-md">
                <div className="bottom-footer__inner flex-between flex-wrap gap-16 py-16">
                    <p className="bottom-footer__text text-white">
                        Pink Peony Shop © 2024. All Rights Reserved{" "}
                    </p>
                    <div className="flex-align gap-8 flex-wrap">
                        <span className="text-sm text-white">We Are Acepting</span>
                        <img src="/assets/images/thumbs/payment-method.png" alt="" />
                    </div>
                </div>
            </div>
        </div>

    )
}

export default BottomFooter